import React, { useState, useEffect } from "react";

const useOptimizeListRenderPerformance = (
  largeListArray,
  additionalFn,
  FnParams,
  ApplyFilter,
  length = 5
) => {
  const [itemsToShow, setItemsToShow] = useState(length);
  const [list, setList] = useState([]);
  const [startY, setStartY] = useState(length);
  const [activated, setActivated] = useState(false);
  const [firstCall, setFirstCall] = useState(true);

  const handleScroll = (e) => {
    if (e.deltaY > 0) {
      setItemsToShow((prev) => prev + 1);
    } else {
      setItemsToShow((prev) => (prev > length ? prev - 1 : prev));
    }
  };

  const handleTouchStart = (e) => {
    setStartY(e.touches[0].clientY);
  };

  const handleTouchMove = (e) => {
    const currentY = e.touches[0].clientY;
    if (currentY > startY) {
      setItemsToShow((prev) => prev + 1);
    } else {
      setItemsToShow((prev) => (prev > length ? prev - 1 : prev));
    }
  };

  useEffect(() => {
    if (largeListArray) {
      let updatedList = largeListArray.slice(0, itemsToShow);
      if (additionalFn) {
        updatedList = additionalFn(updatedList, ...FnParams);
      }
      ApplyFilter
        ? setList(ApplyFilter(largeListArray, FnParams))
        : setList(updatedList);
    }
  }, [largeListArray, itemsToShow, FnParams]);

  useEffect(() => {
    setActivated(true);
    setFirstCall(false);
  }, []);

  return {
    list,
    handleTouchMove,
    handleScroll,
    handleTouchStart,
    activated,
    firstCall,
  };
};

export default useOptimizeListRenderPerformance;
